import React from 'react';
import { compose } from 'ramda';
import styleFile from './MoreInfoFold.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { RichText, Image, Link, Button } from '@synergycms_core/components/generic';
import { CSSTransition } from 'react-transition-group';

let openMoreInfoInstance = null;

const MoreInfoFold = class MoreInfoFold extends React.Component {
  static displayName = 'MoreInfoFold';

  constructor(props) {
    super(props);
    this.state = {
      showMoreInfo: false
    };
  }

  componentWillUnmount() {
    if (openMoreInfoInstance === this) {
      openMoreInfoInstance = null;
    }
  }

  closeMoreInfo = () => {
    if (openMoreInfoInstance === this) {
      openMoreInfoInstance = null;
    }
    this.setState({ showMoreInfo: false });
  };

  toggleMoreInfo = (e) => {
    this.setState((state) => {
      const willOpen = !state.showMoreInfo;
      if (willOpen) {
        if (openMoreInfoInstance && openMoreInfoInstance !== this) {
          openMoreInfoInstance.closeMoreInfo();
        }
        openMoreInfoInstance = this;
      } else if (openMoreInfoInstance === this) {
        openMoreInfoInstance = null;
      }
      return { showMoreInfo: willOpen };
    });
  };

  render() {
    const { theme, config } = this.props;
    const { classes } = theme.styles;
    const { triggerDropTitle, dropText } = config;
    return (
      <div className={theme.computedInnerStyle}>
        <div className={[classes.relativeFoldContainer].join(' ')}>
          <Button
            innerStyle={[classes.btnToggle, this.state.showMoreInfo ? classes.up : classes.down]}
            onClick={this.toggleMoreInfo}
            ariaLabel={triggerDropTitle}
            translate={true}
            richText={{
              text: triggerDropTitle,
              ucFirst: true,
              translate: true,
              innerStyle: [classes.btnText],
              rightIcon: {
                unicodeContent: 'E052',
                innerStyle: [classes.toggleIcon, this.state.showMoreInfo ? classes.up : classes.down]
              }
            }}
          />
        </div>
        <CSSTransition
          in={this.state.showMoreInfo}
          timeout={290}
          classNames={{
            enter: classes.dropDownEnter,
            enterActive: classes.dropDownEnterActive,
            exit: classes.dropDownLeave,
            exitActive: classes.dropDownLeaveActive
          }}
          unmountOnExit>
          {(state) => (
            <div
              className={classes.dropDownContainer}
              style={{
                visibility: state === 'exited' ? 'hidden' : 'visible',
                opacity: state === 'exited' ? 0 : 1
              }}>
              <div className={classes.dropDownOverflow}>
                <RichText
                  ucFirst
                  translate
                  dangerouslySetInnerHTML={dropText}
                  innerStyle={classes.tooltipBenefitText}
                />
              </div>
            </div>
          )}
        </CSSTransition>
      </div>
    );
  }
};
export default compose(
  PropertyManager(['triggerDropTitle', 'dropText']),
  withThemeJSS({ styleFile, link: true, displayName: 'MoreInfoFold' })
)(MoreInfoFold);
